import { useState, useEffect } from 'react'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import LandingPage from './pages/LandingPage'
import LoginPage from './pages/LoginPage'
import Dashboard from './pages/Dashboard'
import BillDetailPage from './pages/BillDetailPage'
import { ErrorBoundary } from './components/ErrorBoundary'
import api from './services/milk-api'

function App() {
  const [user, setUser] = useState<{ name: string; role: string; tenantId: number; userId: number; tenantName: string; mustChangePassword?: boolean; subscriptionWarningMessage?: string | null } | null>(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    // Global error handler to catch uncaught errors
    const handleError = (event: ErrorEvent) => {
      console.error('[App] Uncaught error:', event.error);
      localStorage.setItem('milk_last_error', JSON.stringify({
        message: event.error?.message,
        stack: event.error?.stack,
        timestamp: new Date().toISOString(),
      }));
    };
    const handleRejection = (event: PromiseRejectionEvent) => {
      console.error('[App] Unhandled rejection:', event.reason);
      localStorage.setItem('milk_last_error', JSON.stringify({
        message: String(event.reason),
        stack: event.reason?.stack,
        timestamp: new Date().toISOString(),
      }));
    };
    window.addEventListener('error', handleError);
    window.addEventListener('unhandledrejection', handleRejection);

    // Check for existing session
    const token = api.getToken()
    const saved = localStorage.getItem('milk_user')
    if (token && saved) {
      setUser(JSON.parse(saved))
    }
    setLoading(false)

    return () => {
      window.removeEventListener('error', handleError);
      window.removeEventListener('unhandledrejection', handleRejection);
    };
  }, [])

  const handleLogin = (userData: { name: string; role: string; tenantId: number; userId: number; tenantName: string; mustChangePassword?: boolean; subscriptionWarningMessage?: string | null }) => {
    setUser(userData)
  }

  const handleLogout = () => {
    api.clearToken()
    setUser(null)
  }

  if (loading) {
    return <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>Loading...</div>
  }

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={user ? (
          <ErrorBoundary fallback={(error, reset) => (
            <div style={{ padding: '40px', textAlign: 'center', fontFamily: 'monospace' }}>
              <h2 style={{ color: '#C62828' }}>Dashboard Error</h2>
              <pre style={{ background: '#f5f5f5', padding: '16px', borderRadius: '8px', textAlign: 'left', overflow: 'auto', maxWidth: '800px', margin: '16px auto', fontSize: '13px' }}>
                {error.message}
                {'\n\n'}
                {error.stack}
              </pre>
              <button onClick={reset} style={{ padding: '8px 24px', background: '#43A047', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '14px' }}>Try again</button>
              <button onClick={() => { api.clearToken(); window.location.href = '/'; }} style={{ padding: '8px 24px', background: '#C62828', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '14px', marginLeft: '8px' }}>Logout</button>
            </div>
          )}>
            <Dashboard user={user} onLogout={handleLogout} />
          </ErrorBoundary>
        ) : <LandingPage />} />
        <Route path="/login" element={user ? <Navigate to="/" replace /> : <LoginPage onLogin={handleLogin} />} />
        <Route path="/bill/:billId" element={<BillDetailPage />} />
        <Route path="/*" element={user ? <Navigate to="/" replace /> : <Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  )
}

export default App